import React from 'react';
import { CheckCircle } from 'lucide-react';

export const ContactSuccess = ({ onReset }) => (
  <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center" style={{ paddingTop: '100px' }} data-testid="contact-success">
    <div className="text-center max-w-md mx-auto px-6">
      <CheckCircle className="w-16 h-16 text-[#c9a87c] mx-auto mb-6" />
      <h1 className="text-3xl mb-4" style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 300 }}>
        Message Sent!
      </h1>
      <p className="text-[#b8b8b8] mb-8">
        Thank you for reaching out. I will get back to you as soon as possible to discuss your session.
      </p>
      <button onClick={onReset} className="hero-cta" data-testid="contact-send-another-btn">
        Send Another Message
      </button>
    </div>
  </div>
);
